import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 2C16.355 2 15 3.35499 15 5C15 5.19095 15.0218 5.37712 15.0566 5.55859L7.92188 9.7207C7.39854 9.27785 6.73208 9 6 9C4.35499 9 3 10.355 3 12C3 13.645 4.35499 15 6 15C6.73208 15 7.39854 14.7221 7.92188 14.2793L15.0566 18.4395C15.0216 18.6215 15 18.8084 15 19C15 20.645 16.355 22 18 22C19.645 22 21 20.645 21 19C21 17.355 19.645 16 18 16C17.2675 16 16.6016 16.2793 16.0781 16.7227L8.94336 12.5586C8.97821 12.3771 9 12.191 9 12C9 11.809 8.97821 11.6229 8.94336 11.4414L16.0781 7.2793C16.6015 7.72215 17.2679 8 18 8C19.645 8 21 6.64501 21 5C21 3.35499 19.645 2 18 2ZM18 4C18.5641 4 19 4.43587 19 5C19 5.56413 18.5641 6 18 6C17.4359 6 17 5.56413 17 5C17 4.43587 17.4359 4 18 4ZM6 11C6.56413 11 7 11.4359 7 12C7 12.5641 6.56413 13 6 13C5.43587 13 5 12.5641 5 12C5 11.4359 5.43587 11 6 11ZM18 18C18.5641 18 19 18.4359 19 19C19 19.5641 18.5641 20 18 20C17.4359 20 17 19.5641 17 19C17 18.4359 17.4359 18 18 18Z",
		fill: "currentColor"
	})
});
export default SvgShare;
